module.exports = __webpack_public_path__ + "static/arrow-of-god-ee8f05f39278fc40a91e22d0356a27b3.jpg";